export default "__VITE_ASSET__a0b0d79c__"